import createClient, {} from "openapi-fetch";
const COMMANDS = new Set(["POST", "PUT", "PATCH", "DELETE"]);
/**
 * Typed client for web, admin, and desktop. Adds the bearer token and an Idempotency-Key on commands;
 * browsers send the refresh cookie because credentials are included.
 */
export function createApiClient(options) {
    const client = createClient({
        baseUrl: options.baseUrl,
        credentials: "include",
        ...(options.fetch === undefined ? {} : { fetch: options.fetch }),
    });
    const headers = {
        async onRequest({ request }) {
            const token = await options.getAccessToken?.();
            if (token !== undefined)
                request.headers.set("authorization", `Bearer ${token}`);
            if (COMMANDS.has(request.method) && !request.headers.has("idempotency-key")) {
                request.headers.set("idempotency-key", crypto.randomUUID());
            }
            return request;
        },
    };
    client.use(headers);
    return client;
}
//# sourceMappingURL=client.js.map